import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { RadioBox, Text } from '@jisr-hr/design-system'
import cns from 'classnames'

const RadioBoxField = ({
  label,
  labelKey,
  name,
  onChange,
  options,
  validate,
  valueKey,
  style,
  className = '',
  ...rest
}) => (
  <>
    {options.map((option, i) => (
      <Field
        key={i}
        name={name}
        validate={validate}
      >
        {({ input, meta }) => (
          <>
            <RadioBox
              {...rest}
              {...input}
              style={{ padding: 4, ...style }}
              label={option[labelKey]}
              value={option[valueKey]}
              checked={input.value === option[valueKey]}
              className={cns(className && className, option.className)}
              onChange={(val) => {
                input.onChange(val)
                if (onChange) {
                  onChange(val, option)
                }
              }}
              data-testid={option.testId}
            />
            {i === options.length - 1 && meta.error && meta.touched && (
              <Text
                typography="caption12"
                color="var(--color-feedback-error-dark-new)"
              >
                {meta.error}
              </Text>
            )}
          </>
        )}
      </Field>
    ))}
  </>
)

RadioBoxField.defaultProps = {
  options: [],
  valueKey: 'value',
  labelKey: 'label',
}

RadioBoxField.propTypes = {
  label: PropTypes.string,
  labelKey: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape()),
  validate: PropTypes.string,
  valueKey: PropTypes.string,
  className: PropTypes.string,
}

export default React.memo(RadioBoxField)
